import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, switchMap, tap, throwError } from 'rxjs';

import { actionTokenExpire } from '@core/auth';

import { deleteCookieURL } from './endpoints';

interface GogisNotifyMessage {
  statut: number;
  messages: GogisMessage[];
}

interface GogisMessage {
  field?: string;
  message: string;
  code: string;
}

@Injectable()
export class HttpNotifyInterceptor implements HttpInterceptor {
  constructor(
    private http: HttpClient,
    private store: Store,
    private toastrService: ToastrService,
  ) {}

  private formatMessage(messages: GogisMessage[]): string {
    let formatedMessage = '';
    messages?.forEach((message) => {
      formatedMessage += message.field
        ? `${message.field}: ${message.message} `
        : `${message.message} `;
    });

    return formatedMessage;
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event) => {
        if ((event as any).body?.status && (event as any).body?.messages) {
          this.toastrService.success(
            this.formatMessage((event as any).body.messages),
          );
        }
      }),
      // eslint-disable-next-line rxjs-x/no-implicit-any-catch
      catchError((error: HttpErrorResponse) => {
        if (
          ((request.url.includes('refresh') && error.status === 400) ||
            error.status === 401) &&
          ((error.error as GogisNotifyMessage).messages[0].code ===
            'token_not_valid' ||
            (error.error as GogisNotifyMessage).messages[0].code ===
              'invalid' ||
            (error.error as GogisNotifyMessage).messages[0].code ===
              'token_not_provided' ||
            (error.error as GogisNotifyMessage).messages[0].code ===
              'token_expired' ||
            (error.error as GogisNotifyMessage).messages[0].code ===
              'authentication_failed')
        ) {
          this.store.dispatch(actionTokenExpire());

          return this.http.post(deleteCookieURL, {}).pipe(
            switchMap(() => {
              request = request.clone({
                withCredentials: false,
              });

              return next.handle(request);
            }),
          );
        }

        let formatedError = '';

        (error.error as GogisNotifyMessage)?.messages?.forEach((message) => {
          formatedError += message.field
            ? `${message.field}: ${message.message} `
            : `${message.message} `;
        });

        // Check with backend to format the error
        // see. https://projekti.sungis.lv/issues/3373 & https://projekti.sungis.lv/issues/3605
        formatedError = formatedError || 'Error not formated.';

        if (!request.url.includes('refresh')) {
          // Do not show the toastr in case of first refresh (to check if user is login)
          this.toastrService.error(formatedError);
        }

        return throwError(
          () =>
            new Error(
              this.formatMessage((error.error as GogisNotifyMessage)?.messages),
            ),
        );
      }),
    );
  }
}
